/* eslint-disable global-require */
require(['config'], function () {
    require(['web-urls'], function (webUrls) {
        webUrls.retrieveConfig(true).then(function () {
            require(['main-runner', 'api-access'], function (main, apiAccess) {
                apiAccess.configure(webUrls.getConfigUrls());
                main();
            });
        });
    });
});

define("main", function(){});

